export default __webpack_public_path__ + "static/media/eb-ultra-pro-banner-1.0c2a65a2.jpg";